import clsx from 'clsx'
import { computed, defineComponent } from 'vue'

interface Props {
  tData?: string
  id?: string
  class?: unknown
  color?: string
  disabled?: boolean
  checked?: boolean
  onClick?: ((payload: MouseEvent) => void)
  onMousedown?: ((payload: MouseEvent) => void)
}

export default defineComponent<Props>((props, context) => {
  // #region props Getters

  const tData = computed(() => props.tData ?? 'menu-button')

  const colorClass = computed((): string | undefined => {
    return props.color ?? clsx('menu-btn-gray')
  })

  // #endregion

  return () => {
    return (
      <button
        t-data={tData.value}
        id={props.id}
        class={['menu-btn w-full', colorClass.value, props.class]}
        aria-checked={props.checked}
        disabled={props.disabled}
        type='button'
        onClick={props.onClick}
        onMousedown={props.onMousedown}
      >
        {context.slots.default?.()}
      </button>
    )
  }
}, {
  name: 'MenuButton',
  props: [
    'tData',
    'id',
    'class',
    'color',
    'disabled',
    'checked',
    'onClick',
    'onMousedown'
  ]
})
